import React from "react";
import { useTheme } from "@mui/material/styles";
import { Stack, useMediaQuery } from "@mui/material";

import { GridViewport, InlineContainer, StyledPaper } from "./Player.elements";
import { Viewport } from "../../components/Viewport/Viewport";
import { useViewport, View } from "../../components/Viewport/useViewport";
import { Module } from "../../components/Module/Module";
import { Instructor } from "../../components/Instructor/Instructor";
import { HelpAndSupport } from "./HelpAndSupport";
import { InstructorWrapper } from "./ViewportContent.elements";

export function ViewportContent(): JSX.Element | null {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { view } = useViewport();

  const showInstructor = view !== View.Quiz && view !== View.Survey;
  const viewportClasses = ["viewport"];

  if (view === View.Quiz) {
    viewportClasses.push("fullView");
  }

  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <GridViewport className={viewportClasses.join(" ")}>
        <Viewport />
      </GridViewport>
      {!isTablet && showInstructor ? (
        <StyledPaper>
          <Module />
          <InstructorWrapper>
            <Instructor />
            <HelpAndSupport />
          </InstructorWrapper>
        </StyledPaper>
      ) : (
        <InlineContainer id="inline">
          <Module />
        </InlineContainer>
      )}
    </Stack>
  );
}
